<template>
  <v-container style="height: 100%;">
<!--    <v-parallax src="https://storage.googleapis.com/kokoro-294123.appspot.com/login-bg.jpg" height="80px">-->
<!--      <div class="logo">-->
    <div style="padding:20px; background-color: black;">
        <img src="https://storage.googleapis.com/kokoro-294123.appspot.com/logo-white.svg" width="80%"/>
<!--      </div>-->
<!--      <img src="https://storage.googleapis.com/kokoro-294123.appspot.com/logo-white.svg" style="height: 80px" class="pa-3"/>-->
<!--    </v-parallax>-->
    </div>
    <template v-if="finished == false">
      <div v-if="token === ''">
      <v-row>
        <v-col>
          <b>Enter your username</b>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="py-0">
          <v-text-field type="email" v-model="email" outlined/>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="py-0">
          <v-btn block class="primary" @click="sendVerificationToken()">SEND EMAIL</v-btn>
          <v-btn block text to="/" class="mt-2">back to LOGIN</v-btn>
        </v-col>
      </v-row>
      </div>
      <div v-else>
        <v-card class="my-5" elevation="0">
          <v-card-title>Change Password</v-card-title>
          <v-card-text>
            <v-text-field type="password" label="PASSWORD" v-model="password" :rules="[required]"/>
            <v-text-field type="password" label="CONFIRM" v-model="confirm" :rules="[required, checkMatch]"/>
          </v-card-text>
          <v-card-actions>
            <v-btn block color="primary" @click="verifyToSetPassword">
              SAVE
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </template>
    <template v-else-if="finished == true">
      <v-row>
        <v-col>
          <h4>Finished. Please go to Kokoro Merchant Application to continue.</h4>
        </v-col>
      </v-row>
    </template>
    <v-dialog v-model="passwordReset">
      <v-card class="mx-auto">
        <v-card-title>Password Change</v-card-title>
        <v-card-text>
          Password changed successfully.
          Please open application and try to login with new password.
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="passwordReset=false">
            CLOSE
          </v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="290"
    >
      <v-card v-if="dialogParams">
        <v-card-title class="headline">{{dialogParams.title}}</v-card-title>
        <v-card-text>{{dialogParams.text}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="dialog = false"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <transition name="dissolve">
      <div class="progressView" v-if="isLoading==true">
        <div class="center-container">
          <div class="content-center">
            <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
<!--            <p class="loading-message"> {{loadingMessage}}</p>-->
          </div>

        </div>
      </div>
    </transition>
  </v-container>
</template>

<script>
  import {sendVerificationToken, verifyToSetPassword} from "../api/user";
  import {showDialog} from "../api/utils";
  import EventBus from "../api/event-bus";

    export default {
        name: "ResetPassword",
      data() {
          return {
            email: "",
            password: "",
            confirm: "",
            required: value => !!value || 'Required.',
            passwordReset: false,
            isLoading: false,
            dialog: false,
            dialogParams: false,
            finished:false,
          }
      },
      computed: {
        token(){
          if(this.$route.query.hasOwnProperty("token"))
            return this.$route.query.token

          return ""
        },
        checkMatch(){
          if(this.password === "" || this.confirm === "")
            return false

          if(this.password !== this.confirm)
            return 'Passwords do not match'

          return true
        }
      },
      mounted() {
      },
      beforeDestroy() {
      },
      methods: {
        showDialog: function(message = '', title = '') {
          this.$data.dialogParams = {
            title:title,
            text:message
          }
          this.$data.dialog = true;
          // EventBus.$emit("showDialog", params);
        },
        sendVerificationToken: function () {
          let self = this;
          self.$data.isLoading =  true;
          sendVerificationToken(window.location.origin, this.email)
          .then(function(data){
            self.$data.isLoading =  false;
            console.log(data);
            if(data.success) {
              console.log(data);
              self.showDialog(data.message);
            } else {
              self.showDialog(data.message);
            }
          })
          .catch(function(err) {
            self.$data.isLoading =  false;
            let msg = "Please contact administrator for error " + err;
            if(err.response != undefined) {
              msg += ' (' + err.response + ')';
            }
            self.showDialog(msg, "ERROR");
            self.finished = true;
          })
        },
        verifyToSetPassword: function () {
          let self = this

          if(this.checkMatch)
            self.$data.isLoading =  true;
            verifyToSetPassword(this.token, this.password)
          .then(function(data){
            self.$data.isLoading =  false;
            if(data.success == true) {
              self.$data.passwordReset = true;
            } else {
              self.showDialog(data.message);
            }
            self.finished = true;
          })
          .catch(function(err) {
            self.$data.isLoading =  false;
            self.finished = true;
          })
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ResetPassword.vue